import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { DocumentService } from '@app/shared/services';
import * as FileSaver from 'file-saver';
import { ClipboardService } from 'ngx-clipboard';
import { AnimationOptions } from 'ngx-lottie';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SecurityKeyDialogComponent } from '../security-key-dialog/security-key-dialog.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

export class UsernameValidator {
  static cannotContainSpace(control: AbstractControl): ValidationErrors | null {
    if ((control.value as string).indexOf(' ') >= 0) {
      return { cannotContainSpace: true };
    }

    return null;
  }
}
@AutoUnsubscribe()
@Component({
  selector: 'security-stepper',
  templateUrl: './security-stepper.component.html',
  styleUrls: ['./security-stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecurityStepperComponent implements OnInit, OnDestroy {
  iskeyName: boolean = false;
  isSecurityKey: boolean = false;
  isHint: boolean = false;
  isSafeguardkey: boolean = false;
  hidenextBtn: boolean = false;
  ShareUrl: any = '';
  securityKeysForm: UntypedFormGroup;
  isSecurityKeycreating: boolean = false;
  isSuccessScreen: boolean = false;
  subscription: Subscription = new Subscription();

  successAnimationOptions: AnimationOptions = {
    path: 'assets/lottie/success-tick.json',
  };

  successAnimationOptionsKey: AnimationOptions = {
    path: 'assets/lottie/key-flip.json',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<SecurityStepperComponent>,
    private dialog: MatDialog,
    private documentService: DocumentService,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private _clipboardService: ClipboardService,
    private _fb: UntypedFormBuilder
  ) {
    if (this.data.showkeyName) {
      this.iskeyName = true;
      this.isSecurityKey = false;
      this.isHint = false;
      this.isSafeguardkey = false;
    } else if (this.data.showSecurityKey) {
      this.iskeyName = false;
      this.isSecurityKey = true;
      this.isHint = false;
      this.isSafeguardkey = false;
    } else if (this.data.showHint) {
      this.iskeyName = false;
      this.isHint = true;
      this.isSecurityKey = false;
      this.isSafeguardkey = false;
    } else if (this.data.showSafeguardKey) {
      this.iskeyName = false;
      this.isSafeguardkey = true;
      this.isHint = false;
      this.isSecurityKey = false;
    }
    this.successAnimationOptions;
    this.successAnimationOptionsKey;
  }

  ngOnInit(): void {
    this.securityKeysForm = this._fb.group({
      keyname: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(245), noWhitespaceValidator()]],
      securitykey: [
        '',
        [
          Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+-={};,.<>?~])[A-Za-zd!@#$%^&*()_+-={};,.<>?~0-9].{7,}'),
          Validators.maxLength(245),
        ],
      ],
      confirmSecurityKey: [
        '',
        [
          Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+-={};,.<>?~])[A-Za-zd!@#$%^&*()_+-={};,.<>?~0-9].{7,}'),
          Validators.maxLength(245),
        ],
      ],
      securityHint: [''],
      securityCheckbox: ['', Validators.required],
    });
  }

  async nextItem() {
    if (this.iskeyName) {
      this.iskeyName = false;
      this.isSecurityKey = true;
      this.isHint = false;
      this.isSafeguardkey = false;
    } else if (this.isSecurityKey) {
      this.isSecurityKey = false;
      this.isHint = true;
      this.isSafeguardkey = false;
      this.iskeyName = false;
    } else if (this.isHint) {
      this.isHint = false;
      this.isSecurityKey = false;
      this.iskeyName = false;
      this.isSafeguardkey = true;

      if (this.securityKeysForm.controls['securitykey'].value) {
        this.ShareUrl = this.securityKeysForm.controls['securitykey'].value;
      }
    } else if (this.isSafeguardkey) {
      this.isSafeguardkey = false;
      this.isHint = false;
      this.isSecurityKey = false;
      this.iskeyName = false;
      this.hidenextBtn = true;
      // this.isSuccessScreen = false;
      this.isSecurityKeycreating = true;

      this.cd.markForCheck();

      if (this.isSecurityKeycreating && !this.isSafeguardkey) {
        //  for dom rendering -> since api is getting called before the above written code will run
        await this.createSecuritykey();
      }
    }
  }

  backItem() {
    if (this.isSecurityKey) {
      this.iskeyName = true;
      this.isSecurityKey = false;
      this.isHint = false;
      this.isSafeguardkey = false;
    }
    if (this.isHint) {
      this.isHint = false;
      this.isSecurityKey = true;
      this.isSafeguardkey = false;
      this.iskeyName = false;
    } else if (this.isSafeguardkey) {
      this.isSafeguardkey = false;
      this.isHint = true;
      this.isSecurityKey = false;
      this.iskeyName = false;
    }
  }

  cancelkeySetup() {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Cancel Security Key Setup ',
        materialIcon: 'warning',
        text: 'Are you sure you want to cancel setting up this security key?',
        proceedTitle: 'Leave',
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.dialogRef.close({ isSkip: true });
          // this.dialog.close();
        }
      })
    );
  }

  copy() {
    this._clipboardService.copy(this.ShareUrl);
    this.toastr.success('Security Key copied');
  }

  equalPasswords() {
    if (!(this.securityKeysForm.controls.securitykey.value === this.securityKeysForm.controls.confirmSecurityKey.value)) {
      this.securityKeysForm.controls.confirmSecurityKey.setErrors({ incorrect: true });
    }
    if (this.securityKeysForm.controls.securitykey.value === this.securityKeysForm.controls.confirmSecurityKey.value) {
      this.securityKeysForm.controls.confirmSecurityKey.setErrors(null);
    }
    return this.securityKeysForm.controls.securitykey.value === this.securityKeysForm.controls.confirmSecurityKey.value;
  }

  checkUpperCase(value) {
    return /[A-Z]/.test(value) && /[a-z]/.test(value);
  }
  checSpecialCase(value) {
    return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value);
  }
  checkUnmericCase(value) {
    return /\d/.test(value);
  }

  generateRandomKey(length) {
    let randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789`~!@#$%^&*()_+|}{[]":;?><,./';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    result = `${Math.floor(Math.random() * 10) + 1}${result}${Math.floor(Math.random() * 10) + 1}`;
    this.securityKeysForm.controls['securitykey'].setValue(result);
    this.securityKeysForm.controls['confirmSecurityKey'].setValue(result);
    if (this.securityKeysForm.controls['securitykey'].value) {
      this.ShareUrl = this.securityKeysForm.controls['securitykey'].value;
    }
  }

  async createSecuritykey() {
    if (this.securityKeysForm.controls['securityCheckbox'].value) {
      let payload;
      if (this.securityKeysForm.controls['securityHint'].value) {
        payload = {
          keyName: this.securityKeysForm.controls['keyname'].value.trim(),
          key: this.securityKeysForm.controls['securitykey'].value,
          hint: this.securityKeysForm.controls['securityHint'].value,
        };
      } else {
        payload = {
          keyName: this.securityKeysForm.controls['keyname'].value.trim(),
          key: this.securityKeysForm.controls['securitykey'].value,
        };
      }

      if (this.data.workspace_id && this.data.workspace_user_id) {
        payload['workspace_id'] = this.data.workspace_id;
        payload['workspace_user_id'] = this.data.workspace_user_id;
      }

      await this.documentService.generateKeyAsync(payload.key).then((res: any) => {
        payload.encrypted_key = res.encrypted_key;
        payload.public_key = res.public_key;

        this.subscription.add(
          this.documentService.createSecuritykey(payload).subscribe(
            (res) => {
              if (res.status == 200) {
                this.isSecurityKeycreating = false;
                this.isSuccessScreen = true;
                // success animation wait
                setTimeout(() => {
                  this.dialogRef.close({
                    confirmation: true,
                    payload: payload,
                  });
                }, 2000);
                this.cd.markForCheck();
              } else {
                this.isHint = false;
                this.isSecurityKey = false;
                this.iskeyName = false;
                this.isSafeguardkey = true;
                this.isSecurityKeycreating = false;
                this.isSuccessScreen = false;
                this.hidenextBtn = false;
                this.cd.detectChanges();
              }
            },
            (error) => {}
          )
        );
      });
    }
  }

  downloadFile() {
    if (this.securityKeysForm.controls['securitykey'].value && this.securityKeysForm.controls['keyname'].value.trim()) {
      var blob = new Blob([`${this.securityKeysForm.controls['securitykey'].value}`], { type: 'text/plain;charset=utf-8' });
      FileSaver.saveAs(blob, `${this.securityKeysForm.controls['keyname'].value.trim()}.txt`);
    }
  }

  onPercentChangeKey(percent: any) {
    let number = percent.length;
    if (number > 100) {
      number = 85;
      eval(`document.querySelector(".security-key-textarea-Key .mat-form-field-wrapper .mat-form-field-flex").style.height='${number}px'`);
      eval(
        `document.querySelector(".security-key-textarea-Key .mat-form-field-wrapper .mat-form-field-flex .mat-input-element").style.height='${number}px'`
      );
    } else {
      eval(`document.querySelector(".security-key-textarea-Key .mat-form-field-wrapper .mat-form-field-flex").style.height='${48}px'`);
      eval(
        `document.querySelector(".security-key-textarea-Key .mat-form-field-wrapper .mat-form-field-flex .mat-input-element").style.height='${20}px'`
      );
    }
  }

  onPercentChangeConfirmKey(percent: any) {
    let number = percent.length;
    if (number > 100) {
      number = 85;
      eval(`document.querySelector(".security-key-textarea-confirmKey .mat-form-field-wrapper .mat-form-field-flex").style.height='${number}px'`);
      eval(
        `document.querySelector(".security-key-textarea-confirmKey .mat-form-field-wrapper .mat-form-field-flex .mat-input-element").style.height='${number}px'`
      );
    } else {
      eval(`document.querySelector(".security-key-textarea-confirmKey .mat-form-field-wrapper .mat-form-field-flex").style.height='${48}px'`);
      eval(
        `document.querySelector(".security-key-textarea-confirmKey .mat-form-field-wrapper .mat-form-field-flex .mat-input-element").style.height='${20}px'`
      );
    }
  }

  openSecurityKeyDialog() {
    this.dialog.open(SecurityKeyDialogComponent, {
      data: { securityKey: this.ShareUrl, isHint: true },
      panelClass: 'security-key-dialog',
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  whiteSpaceTrimForForm(value: string) {
    return value.toLowerCase().trim();
  }
}
function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isWhitespace = (control.value || '').trim().length < 4;
    return isWhitespace ? { whitespace: true } : null;
  };
}
